import { render, staticRenderFns } from "./CollectionPointSearchPage.vue?vue&type=template&id=7011a19e&scoped=true"
import script from "./CollectionPointSearchPage.vue?vue&type=script&lang=js"
export * from "./CollectionPointSearchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7011a19e",
  null
  
)

export default component.exports